import ProfileAvatar from "./profile-avatar.jpg";
import TabletScreen from "./tabletscreen.png";
import LandingPageBG from "./landing-page-bg.png";
import Logo from "./logo.png";
import FBLogo from "./fb-logo.png";
import InstagramLogo from "./insta-logo.png";
import LinkedInLogo from "./linkedIn-logo.png";
import ScrollDownButton from "./scroll-down-btn.png";
import Doctor from "./doctor.png";
import ListStyleIcon from "./listStyleIcon.png";
import Section3Right from "./lifecycle.png";
import Section3Left from "./section3-left.png";
import Section4Left from "./section4-left.png";
import Section4Right from "./section4-right.png";
import Section5Right from "./section5-tablet.png";
import Section5ChatWomanPic from "./chat-woman-pic.png";
import Section5ChatDoctorPic from "./chat-doctor-pic.png";
import Section6BG from "./section6-bg.png";
import Section7BG from "./section7-bg.png";
import FooterLogo from "./footer-logo.png";
import Asia from "./asia.png";
import NorthAmericaLogo from "./north-america-logo.png";
import MenaLogo from "./mena-logo.png";
import EuropeLogo from "./europe-logo.png";
import AddressLogo from "./address-logo.png";
import EmailLogo from "./email-logo.png";
import WebsiteLogo from "./website-logo.png";
import FooterFBLogo from "./footer-fb-logo.png";
import FooterInstagramLogo from "./footer-insta-logo.png";
import FooterLinkedInLogo from "./footer-linkedIn-logo.png";
import Section2BG from "./section2-bg.png";
import InnovaLogoBG from "./logo-bg.png";
import WhyChooseUs from "./whyChooseUs.png";
import DashboardDesign from "./dashboardDesign.png";
import Section41 from "./section4(1).png";
import AuthLogo from "./auth-logo.png";
import DasboardInnovaLogo from "./dashboard-innova-logo.png";
import PatientDashboardDoctor from "./patient-dashboard-doctor.png";
import DashboardDoctorTopImage from "./dashboard-doctor-top-img.png";
import FindADoctor from "./find-a-doctor.png";
import Appointment from "./appointment.png";
import ViewMessage from "./view-message.png";
import UnreadMessagesIcon from "./dashboard-chat-icon.png";
import CalenderIcon from "./calender-icon.png";
import ReminderIcon from "./reminder-icon.png";
import CommunityIcon from "./community-icon.png";
import TrueIcon from "./true-icon.png";
import FalseIcon from "./false-icon.png";
import DashboardDoctorsImage from "./dashboard-doctor-img.png";
import DashboardDoctorsImageRight from "./dashboard-doctor-img-right.png";
import DoctorDashboardCalenderIcon from "./doctor-dashboard-calender-icon.png";
import SidebarAppointmentsIcon from "./sidebar-appointments-icon.png";
import SidebarCommunityIcon from "./sidebar-community-icon.png";
import SidebarDashboardIcon from "./sidebar-dashboard-icon.png";
import SidebarEMRIcon from "./sidebar-EMR-icon.png";
import SidebarLogoutIcon from "./sidebar-logout-icon.png";
import SidebarManageProfileIcon from "./sidebar-manage-profile-icon.png";
import SidebarMedConvoIcon from "./sidebar-med-convo-icon.png";
import SidebarPrescriptionIcon from "./sidebar-prescription-icon.png";
import SidebarSearchIcon from "./sidebar-search-icon.png";
import SidebarSettingIcon from "./sidebar-setting-icon.png";
import SidebarViewProfileIcon from "./sidebar-view-profile-icon.png";
import CommunityProfileImageFemale from "./community-profile-img-female.png";
import CommunityProfileImageMale from "./community-profile-img-male.png";
import DoctorProfileImage from "./doctor-profile-img.png";
import PatientProfileImage from "./patient-profile-img.png";
import Panadol from "./panadol.png";
import Rosuvastatin from "./rosuvastatin.png";
import MessagesProfileImage from "./messages-profile-img.png";
import QRCodeImage from "./qr-code-img.png";

export const IMAGES = {
  AVATAR: ProfileAvatar,
  TABLETSCREEN: TabletScreen,
  LANDINGPAGEBG: LandingPageBG,
  LOGO: Logo,
  FBLOGO: FBLogo,
  INSTAGRAMLOGO: InstagramLogo,
  LINKEDINLOGO: LinkedInLogo,
  SCROLLDOWNBUTTON: ScrollDownButton,
  DOCTOR: Doctor,
  LISTSTYLEICON: ListStyleIcon,
  SECTION3LEFT: Section3Left,
  SECTION3RIGHT: Section3Right,
  SECTION4LEFT: Section4Left,
  SECTION4RIGHT: Section4Right,
  SECTION5RIGHT: Section5Right,
  SECTION5CHATWOMANPIC: Section5ChatWomanPic,
  SECTION5CHATDOCTORPIC: Section5ChatDoctorPic,
  SECTION6BG: Section6BG,
  SECTION7BG: Section7BG,
  FOOTERLOGO: FooterLogo,
  ASIALOGO: Asia,
  NORTHAMERICALOGO: NorthAmericaLogo,
  MENALOGO: MenaLogo,
  EUROPELOGO: EuropeLogo,
  ADDRESSLOGO: AddressLogo,
  EMAILLOGO: EmailLogo,
  WEBSITELOGO: WebsiteLogo,
  FOOTERFBLOGO: FooterFBLogo,
  FOOTERINSTAGRAMLOGO: FooterInstagramLogo,
  FOOTERLINKEDINLOGO: FooterLinkedInLogo,
  SECTION2BG: Section2BG,
  INNOVALOGOBG: InnovaLogoBG,
  WHYCHOOSEUS: WhyChooseUs,
  DASHBOARDDESIGN: DashboardDesign,
  SECTION41: Section41,
  AUTHLOGO: AuthLogo,
  DASHBOARDINNOVALOGO: DasboardInnovaLogo,
  PATIENTDASHBOARDDOCTOR: PatientDashboardDoctor,
  DASHBOARDDOCTORTOPIMAGE: DashboardDoctorTopImage,
  FINDADOCTOR: FindADoctor,
  APPOINTMENT: Appointment,
  VIEWMESSAGE: ViewMessage,
  UNREADMESSAGESICON: UnreadMessagesIcon,
  CALENDERICON: CalenderIcon,
  REMINDERICON: ReminderIcon,
  COMMUNITYICON: CommunityIcon,
  TRUEICON: TrueIcon,
  FALSEICON: FalseIcon,
  DASHBOARDDOCOTORSIMAGE: DashboardDoctorsImage,
  DASHBOARDDOCOTORSIMAGERIGHT: DashboardDoctorsImageRight,
  DOCTORDASHBOARDCALENDERICON: DoctorDashboardCalenderIcon,
  SIDEBARAPPOINTMENTSICON: SidebarAppointmentsIcon,
  SIDEBARCOMMUNITYICON: SidebarCommunityIcon,
  SIDEBARDASHBOARDICON: SidebarDashboardIcon,
  SIDEBAREMRICON: SidebarEMRIcon,
  SIDEBARLOGOUTICON: SidebarLogoutIcon,
  SIDEBARMANAGEPROFILEICON: SidebarManageProfileIcon,
  SIDEBARMEDCONVOICON: SidebarMedConvoIcon,
  SIDEBARPRESCRIPTIONICON: SidebarPrescriptionIcon,
  SIDEBARSEARCHICON: SidebarSearchIcon,
  SIDEBARSETTINGICON: SidebarSettingIcon,
  SIDEBARVIEWPROFILEICON: SidebarViewProfileIcon,
  COMMUNITYPROFILEIMAGEFEMALE: CommunityProfileImageFemale,
  COMMUNITYPROFILEIMAGEMALE: CommunityProfileImageMale,
  DOCTORPROFILEIMAGE: DoctorProfileImage,
  PATIENTPROFILEIMAGE: PatientProfileImage,
  PANADOL: Panadol,
  ROSUVASTATIN: Rosuvastatin,
  MESSAGESPROFILEIMAGE: MessagesProfileImage,
  QRCODEIMG: QRCodeImage,
};
